

































import { Vue, Component, Prop } from 'vue-property-decorator';
import ReadDrdCaption from './read-drd-caption.component.vue';

@Component({
  components: { ReadDrdCaption },
})
export default class ReadDrdCaptions extends Vue {
  @Prop({ type: Boolean, default: false })
  dense !: boolean

  @Prop({ type: Boolean, default: false })
  flat !: boolean
}
